import {
  AlertTrigger,
  OrderRouteItem,
  ROUTE_ITEM_LABELS,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { NavGroup, NavItemType } from './types.ts';

const INSPECTIFY_SUBNAV_LABELS: Partial<
  Record<(typeof schPairedCostRouteItem.options)[number], string>
> = {
  details: 'Order',
  features: 'Comparables',
  'adjustments-grid': 'Adjustments',
};

const SUBNAV_ALERT_TRIGGERS: Partial<
  Record<(typeof schPairedCostRouteItem.options)[number], AlertTrigger>
> = {
  market: 'navigate/market',
  features: 'navigate/sales-comparables',
  'cost-approach': 'navigate/cost-approach',
  'adjustments-grid': 'navigate/adjustments',
  'appraisify-commentary': 'navigate/commentary',
  reconciliation: 'navigate/reconciliation',
  'rental-features': 'navigate/rental-comparables',
};

export const craftsmanUIHeaderNavItems: Record<OrderRouteItem, NavItemType> = {
  'paired-cost': {
    label: 'Appraisify',
    route: 'paired-cost',
    subnav: schPairedCostRouteItem.options.map((route) => ({
      label: INSPECTIFY_SUBNAV_LABELS[route] ?? ROUTE_ITEM_LABELS[route],
      route,
      parentRoute: 'paired-cost',
      alertTrigger: SUBNAV_ALERT_TRIGGERS[route],
      ...(route === 'commentary'
        ? {
            items: [
              {
                label: 'Dep. Cost Adjustments',
                route: 'dep-cost',
                parentRoute: 'paired-cost',
                testID: 'dep-cost-nav-item',
              },
              {
                label: 'Site Extraction',
                route: 'site-extraction',
                parentRoute: 'paired-cost',
                testID: 'site-extraction-nav-item',
              },
              {
                label: 'Date of Sale Adjustments',
                route: 'date-of-sale-adjustments',
                parentRoute: 'paired-cost',
                testID: 'date-of-sale-adjustments-nav-item',
              },
              {
                label: 'Methodology',
                route: 'methodology',
                parentRoute: 'paired-cost',
                testID: 'methodology-nav-item',
              },
            ],
          }
        : {}),
    })),
  },
  studies: { label: 'Paired Sales', route: 'studies' },
};

export const APPRAISIFY_ONLY_ROUTES = [
  'details',
  'reconciliation',
  'appraisify-commentary',
  'features',
  'adjustments-grid',
  'cost-approach',
  'rental-features',
];

export const RENTAL_COMPARABLES_ROUTES = ['rental-features'];

export const SAAS_ONLY_ROUTES = [
  'analysis',
  'craftsman-cost-approach',
  'commentary',
  'adjustments',
];

export const DESKTOP_TOP_NAV_GROUPS: readonly NavGroup<OrderRouteItem>[] = [
  { label: 'APPRAISIFY', routes: ['paired-cost'] },
];

export const INSPECTIFY_SUBNAV_GROUPS: NavGroup<(typeof schPairedCostRouteItem.options)[number]>[] =
  [
    { label: 'START', routes: ['details'] },
    {
      label: 'SALES',
      routes: ['features', 'market', 'cost-approach', 'adjustments-grid', 'appraisify-commentary'],
    },
    {
      label: 'RENTALS',
      routes: ['rental-features'],
    },
    { label: 'FINAL', routes: ['reconciliation'] },
  ];

export const SAAS_SUBNAV_GROUPS: NavGroup<(typeof schPairedCostRouteItem.options)[number]>[] = [
  {
    label: 'SALES',
    routes: ['market', 'analysis', 'adjustments', 'commentary', 'craftsman-cost-approach'],
  },
];
